import { Badge, RadioCard } from "@intility/bifrost-react";
import type { AuthMethod } from "../api/types";
import "./NewClientForm.css";

// "Does the workload run on Developer Platform 2.0?": how a service client
// authenticates (ADR-0049), asked where the workload runs. Two cards that
// fill the width. With no `value`, nothing is picked yet.
export function NewClientCredentialQuestion({
  value,
  onChange,
  name,
}: {
  value: AuthMethod | undefined;
  onChange: (value: AuthMethod) => void;
  /** The radio group's name, unique on the page. */
  name: string;
}) {
  return (
    <fieldset className="new-client-fieldset">
      <legend className="bf-label bf-medium new-client-legend">
        Does the workload run on Developer Platform 2.0?
      </legend>
      <p className="bf-medium bfc-base-2 new-client-help">
        This decides how the client authenticates. It cannot be changed after
        creation
      </p>
      <div className="new-client-cards">
        <RadioCard
          name={name}
          checked={value === "spiffe"}
          onChange={() => onChange("spiffe")}
          label={
            <>
              Yes <Badge pill>SPIFFE</Badge>
            </>
          }
        >
          <span className="bfc-base-2">
            The pod gets a workload ID from SPIRE. You must later register the
            workload identity in a namespace.
          </span>
        </RadioCard>
        <RadioCard
          name={name}
          checked={value === "secret"}
          onChange={() => onChange("secret")}
          label={
            <>
              No{" "}
              <Badge pill state="neutral">
                Client secret
              </Badge>
            </>
          }
        >
          <span className="bfc-base-2">
            You store the secret and rotate it yourself.
          </span>
        </RadioCard>
      </div>
    </fieldset>
  );
}
